import type { Category } from "@/constants/categories";

type ChocoBarsProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  chocolate:
    "https://images.unsplash.com/photo-1623660053975-cf75a8be0908?crop=entropy&cs=srgb&fm=jpg&q=85",
  candy:
    "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?crop=entropy&cs=srgb&fm=jpg&q=85",
  gum:
    "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?crop=entropy&cs=srgb&fm=jpg&q=85",
  granola:
    "https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
  image: string,
): ChocoBarsProduct => ({
  id,
  name,
  categorySlug: "choco-bars",
  brand,
  unit,
  price,
  image,
});

export const CHOCOBARS_PRODUCTS: ChocoBarsProduct[] = [
  // Gum
  item("chb-trident-berry-lime", "Trident Chewing Gum Berry Lime", "Trident", "14 pcs", 2.49, IMG.gum),
  item("chb-trident-original", "Trident Chewing Gum Original", "Trident", "14 pcs", 2.49, IMG.gum),
  item("chb-trident-watermelon", "Trident Chewing Gum Watermelon", "Trident", "14 pcs", 2.49, IMG.gum),

  // Bars
  item("chb-bounty", "Bounty Bar", "Mars", "57g", 2.99, IMG.chocolate),
  item("chb-snickers", "Snickers Bar", "Mars", "50g", 2.99, IMG.chocolate),
  item("chb-milka-milk", "Milka Alpine Milk", "Milka", "100g", 4.49, IMG.chocolate),
  item("chb-milka-hazelnut", "Milka Hazelnut", "Milka", "100g", 4.79, IMG.chocolate),
  item("chb-milka-oreo", "Milka Oreo", "Milka", "100g", 4.99, IMG.chocolate),
  item("chb-milka-strawberry", "Milka Strawberry", "Milka", "100g", 4.79, IMG.chocolate),
  item("chb-milka-caramel", "Milka Caramel", "Milka", "100g", 4.79, IMG.chocolate),

  // Granola / cereal bars
  item("chb-muesli-fruit", "Muesli Bar Fruit Mix", "Muesli", "6 pack", 5.99, IMG.granola),
  item("chb-muesli-choco", "Muesli Bar Chocolate", "Muesli", "6 pack", 5.99, IMG.granola),
  item("chb-muesli-honey", "Muesli Bar Honey Oats", "Muesli", "6 pack", 5.99, IMG.granola),
  item("chb-muesli-apple", "Muesli Bar Apple Crunch", "Muesli", "6 pack", 5.99, IMG.granola),
  item("chb-nature-valley-crunchy", "Nature Valley Crunchy Oats", "Nature Valley", "210g", 6.99, IMG.granola),
  item("chb-nature-valley-honey", "Nature Valley Oats & Honey", "Nature Valley", "210g", 6.99, IMG.granola),
  item("chb-nature-valley-protein", "Nature Valley Protein Peanut", "Nature Valley", "160g", 7.49, IMG.granola),
  item("chb-nature-valley-nut", "Nature Valley Nut Butter", "Nature Valley", "160g", 7.49, IMG.granola),

  // Soft candy / sweets
  item("chb-skittles-fruits", "Skittles Fruits", "Skittles", "61g", 2.49, IMG.candy),
  item("chb-skittles-sours", "Skittles Sours", "Skittles", "61g", 2.49, IMG.candy),
  item("chb-skittles-wild-berry", "Skittles Wild Berry", "Skittles", "61g", 2.49, IMG.candy),
  item("chb-chewy-toffees", "Chewy Toffees", "Toffino", "120g", 3.29, IMG.candy),
  item("chb-milk-toffee", "Milk Toffee", "Creamy Bite", "120g", 3.29, IMG.candy),
  item("chb-fruit-toffee", "Fruit Toffee", "Candy Pop", "120g", 3.29, IMG.candy),
  item("chb-jelly-candies", "Jelly Candies Mix", "Sweeto", "150g", 3.99, IMG.candy),

  // Boxed chocolates
  item("chb-assorted-pralines", "Assorted Pralines", "Choco Luxe", "180g", 8.99, IMG.chocolate),
  item("chb-cocoa-bites", "Cocoa Bites", "Cocoa Treats", "150g", 6.49, IMG.chocolate),
  item("chb-wafer-rolls", "Chocolate Wafer Rolls", "Crispy Joy", "125g", 4.99, IMG.chocolate),
];

